export default function APP_URL(resource, subdomain = true, isDev = false) {
    const validResources = ["orders", "orders-batch", "print", "manual-wh", "utrack", "core-v2", "notifications", "products", "auth", "utils", "wallet"];
    if (!validResources.includes(resource)) {
        console.error(`Invalid resource: ${resource}. Valid resources are: ${validResources.join(", ")}`);
        return "";
    }
    let urlToReturn = "";
    switch (resource) {
        case "orders":
            if (subdomain)
                urlToReturn = "https://api.proship.me/orders/v1";
            else
                urlToReturn = "https://60jbdsf4zl.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;
        case "print":
            if (subdomain)
                urlToReturn = "https://api.proship.me/print/v1/print-label";
            else
                urlToReturn = "https://7coiru45qb.execute-api.ap-southeast-1.amazonaws.com/dev/v1/print-label";
            break;
        case "manual-wh":
            if (subdomain)
                urlToReturn = "https://api.proship.me/manual-wh/v1/manual-wh";
            else
                urlToReturn = "https://5pwi41xar4.execute-api.ap-southeast-1.amazonaws.com/dev/v1/manual-wh";
            break;
        case "utrack":
            if (subdomain)
                urlToReturn = "https://api.proship.me/utrack/v1";
            else
                urlToReturn = "https://584i7lz3vc.execute-api.ap-southeast-1.amazonaws.com/dev/v1/";
            break;
        case "core-v2":
            if (subdomain)
                urlToReturn = "https://api.proship.me/core/v1";
            else
                urlToReturn = "https://x1pukio3fj.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;
        case "notifications":
            if (subdomain)
                urlToReturn = "https://api.proship.me/notifications/v1";
            else
                urlToReturn = "https://lqyaow712a.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;
        case "products":
            if (subdomain)
                urlToReturn = "https://api.proship.me/products/v1";
            else
                urlToReturn = "https://oyljzciuy1.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;
        case "auth":
            if (subdomain)
                urlToReturn = "https://api.proship.me/auth/v1";
            else
                urlToReturn = "https://tbtrglpsa0.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;
        case "utils":
            if (subdomain)
                urlToReturn = "https://api.proship.me/utils/v1";
            else
                urlToReturn = "https://a3jczw1yof.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;
        case "wallet":
            if (subdomain)
                urlToReturn = "https://api.proship.me/wallet/v1";
            else
                urlToReturn = "https://6vpe8vkzl6.execute-api.ap-southeast-1.amazonaws.com/dev/v1";
            break;

        case "orders-batch":
            if (subdomain)
                urlToReturn = "https://api.proship.me/batch/v1";
            else
                urlToReturn = "https://kgx8.execute-api.ap-southeast-1.amazonaws.com/dev/v1/batch";
            break;
        default:
            urlToReturn = "https://app.proship.co.th/hehe";
    }

    if (isDev) {
        // replace from start up to and including "/dev/v1" with localhost base
        urlToReturn = urlToReturn.replace(/^https:\/\/[^\/]+\/dev\/v1/, "http://localhost:3000");
    }

    return urlToReturn;
}